import { Link } from "react-router-dom";
import Disclaimer from "../../components/Disclaimer/Disclaimer";
import Layout from "../../components/Layout/Layout";

const About = () => {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-16 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          A project of Earthbound Martian
        </p>
        <h1 className="text-5xl font-bold text-alt-blk mt-3">About Darkskies</h1>
        <p className="text-xl text-alt-blk/80 mt-6 leading-relaxed">
          Find dark skies you can actually stay under. This is a practical,
          free tool for stargazing, astrophotography, and travelers who sleep
          on site in a van or self-contained vehicle.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">What v1 is</h2>
        <p className="leading-relaxed mb-4">
          A map of night lights, a modest list of vehicle-friendly dark
          locations (Texas, the Southwest, and the West first; Alaska, Canada,
          and Mexico as the map grew), and a calendar of new-moon windows and
          major meteor showers. Useful first. Promotional second.
        </p>
        <p className="leading-relaxed">
          It is not a weather app, a planetarium, or a replacement for dedicated
          light-pollution maps. Lunar anomaly catalogs live at{" "}
          <a
            href="https://lunamalies.earthboundmartian.com"
            className="text-turquoise hover:text-mars"
          >
            Lunamalies
          </a>
          .
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Data</h2>
        <Disclaimer />
        <p className="leading-relaxed mt-4">
          The overlay is{" "}
          <a
            className="text-turquoise hover:text-mars"
            href="https://earthdata.nasa.gov/data/projects/black-marble"
            target="_blank"
            rel="noreferrer"
          >
            NASA Black Marble
          </a>{" "}
          (VIIRS night lights via GIBS). Brighter pixels are light sources, not
          a zenith sky-brightness reading. Clicking the map samples that
          imagery for a qualitative label. Curated Bortle classes are typical
          published / commonly cited values for those parks and basins — they
          are not measurements from your night.
        </p>
        <p className="leading-relaxed mt-4">
          Place search uses{" "}
          <a
            className="text-turquoise hover:text-mars"
            href="https://photon.komoot.io"
            target="_blank"
            rel="noreferrer"
          >
            Photon
          </a>{" "}
          (OpenStreetMap). Moon phase is a synodic estimate. Shower nights
          follow the AMS working list through 2027; after that we fall back to
          typical annual dates until a live calendar is wired in.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Overnight access</h2>
        <p className="leading-relaxed">
          Pins mean “this is a known, vehicle-reachable dark-sky stay,” not
          “you are guaranteed a legal campsite tonight.” Permits, length
          limits, seasonal closures, and fire restrictions change. Check the
          land manager. Be self-contained. Leave the sky darker than you found
          it.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Earthbound Martian</h2>
        <p className="leading-relaxed mb-6">
          Darkskies is built for the same people who want comfortable
          multi-night stays under dark skies. If that is your kind of work, the
          Landships are for that kind of work. No hard sell — just a door back
          to the shop.
        </p>
        <div className="flex flex-wrap gap-3">
          <a
            href="https://earthboundmartian.com"
            className="inline-block bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold"
          >
            Visit Earthbound Martian
          </a>
          <Link
            to="/contact"
            className="inline-block border border-alt-blk px-8 py-4 rounded-2xl font-semibold hover:bg-alt-blk hover:text-white transition-colors"
          >
            Contact
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default About;
